var _style, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWarningIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 19.7 17.5",
    style: {
      enableBackground: "new 0 0 19.7 17.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#F21111;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M19,11.9L13.1,2c-0.8-1.3-2-2-3.3-2S7.3,0.7,6.6,2l-5.9,9.9c-0.8,1.3-0.9,2.7-0.2,3.8c0.6,1.1,1.9,1.8,3.4,1.8 h12c1.5,0,2.8-0.6,3.4-1.8C19.9,14.6,19.8,13.2,19,11.9z M9.8,14c-0.9,0-1.6-0.7-1.6-1.5c0-0.9,0.7-1.6,1.6-1.6s1.6,0.7,1.6,1.6 C11.4,13.3,10.7,14,9.8,14z M11.5,6.6c0,0-1.4,3.5-1.4,3.5c0,0.1-0.1,0.2-0.2,0.2s-0.2-0.1-0.2-0.2L8.2,6.6C8.1,6.4,8.1,6.2,8.1,6 c0-1,0.8-1.8,1.8-1.8S11.6,5,11.6,6C11.6,6.2,11.5,6.4,11.5,6.6z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningIcon);
export default __webpack_public_path__ + "static/media/warning_icon.8ee47b9f8c7f68b34c8f6200a8c837c4.svg";
export { ForwardRef as ReactComponent };